var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { allRequestsHaveCompleted, AsyncRequestStatus, } from '@ane/core/lib/models';
import { reduxActionTypePrefix } from '../../../constants/module.constants';
import FeatureResourcesInstance from '@ane/exp-data/lib/resources/FeatureResources';
import { getExperimentationGroupIdFromPath } from '@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils';
import MdsDataplaneResources from '@ane/exp-data/lib/resources/MdsDataplaneResource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { combineEpics } from 'redux-observable';
import AnalysisResource from '@ane/exp-data/lib/resources/expapiv2/Analysis.resource';
import LegacyAnalysisResource from '@ane/exp-data/lib/resources/AnalysisResource';
import _ from 'lodash';
import { getAnalysisGroupDeleteData } from '../../../selectors';
import { AnalysisResources } from '@ane/summary-app-module/lib/module/views/Analysis/module/AnalysisResources';
import MetricServiceResource from '@ane/exp-data/lib/resources/MetricServiceResource';
import { afterLoadAnalysisConfigActions, setMetricsAnalysisTemplatesInReduxWhenLoaded, setMetricsAnalysisTemplatesInReduxWhenLoading, } from './ProgressionScorecard.ducks.utils';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
const analysisResourcesInstance = new AnalysisResources();
export var IReducerKeys;
(function (IReducerKeys) {
    IReducerKeys["features"] = "features";
    IReducerKeys["mds_data"] = "mds_data";
    IReducerKeys["analysis_data"] = "analysis_data";
    IReducerKeys["metrics_analysis_template_data"] = "metrics_analysis_template_data";
    IReducerKeys["analysis_delete_data"] = "analysis_delete_data";
    IReducerKeys["root_feature_async"] = "root_feature_async";
    IReducerKeys["mds_control_tower_experience_async"] = "mds_control_tower_experience_async";
    IReducerKeys["mds_analysis_config_async"] = "mds_analysis_config_async";
    IReducerKeys["analysis_group_async"] = "analysis_group_async";
    IReducerKeys["create_analysis_group_async"] = "create_analysis_group_async";
    IReducerKeys["analysis_group_delete_async"] = "analysis_group_delete_async";
    IReducerKeys["analysis_template_async"] = "analysis_template_async";
    IReducerKeys["analysis_request_form_async"] = "analysis_request_form_async";
    IReducerKeys["feature_auto_trigger_state_async"] = "feature_auto_trigger_state_async";
})(IReducerKeys || (IReducerKeys = {}));
export const defaultReducerState = () => ({
    [IReducerKeys.features]: {},
    [IReducerKeys.mds_data]: {},
    [IReducerKeys.analysis_data]: {},
    [IReducerKeys.analysis_delete_data]: {},
    [IReducerKeys.metrics_analysis_template_data]: {},
});
export var MasterDataSections;
(function (MasterDataSections) {
    MasterDataSections["AnalysisConfig"] = "AnalysisConfig";
    MasterDataSections["ControlTowerExperience"] = "ControlTowerExperience";
    MasterDataSections["ExperimentAlerts"] = "ExperimentAlerts";
    MasterDataSections["ExperimentExtensions"] = "ExperimentExtensions";
    MasterDataSections["ExperimentTemplates"] = "ExperimentTemplates";
    MasterDataSections["ExperimentTrafficFilters"] = "ExperimentTrafficFilters";
    MasterDataSections["FlightControl"] = "FlightControl";
    MasterDataSections["JobExecutionMetadata"] = "JobExecutionMetadata";
    MasterDataSections["MetricSetProperties"] = "MetricSetProperties";
    MasterDataSections["Monitoring"] = "Monitoring";
    MasterDataSections["ProgressionTemplates"] = "ProgressionTemplates";
    MasterDataSections["SystemHealthMessage"] = "SystemHealthMessage";
    MasterDataSections["TicketCategories"] = "TicketCategories";
})(MasterDataSections || (MasterDataSections = {}));
export const getMdsSection = (input, section) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(input.workspaceId, input.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
        workspaceId: input.workspaceId,
        experimentationGroup,
        section,
    });
};
const loadRootFeatureArgs = {
    actionPrefix: `${reduxActionTypePrefix}/LOAD_FEATURE`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.features,
        inputPayload.featureId,
        IReducerKeys.root_feature_async,
    ],
    loadResource: (payload) => FeatureResourcesInstance.loadRootFeatureV2(payload.featureId),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        var _a, _b, _c;
        const { ManagementGroup: managementGroup, WorkspaceId: workspaceId } = outputPayload;
        const experimentStepId = (_c = (_b = (_a = outputPayload.Phases) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.StepIds) === null || _c === void 0 ? void 0 : _c[0];
        return [
            loadMdsControlTowerExperienceEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
            loadMdsAnalysisConfigEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
            ...(EnvironmentService.enableAutoTriggerToggle()
                ? [loadFeatureAutoTriggerStateEpicReducer.actionCreators.load({ workspaceId, featureId: inputPayload.featureId })]
                : []),
            ...(!!experimentStepId
                ? [
                    loadAnalysisGroupEpicReducer.actionCreators.load({ workspaceId, experimentStepId }),
                    loadAnalysisRequestFormEpicReducer.actionCreators.load({ experimentStepId }),
                ]
                : []),
        ];
    },
};
export const loadRootFeatureEpicReducer = loadResourcesUtils(loadRootFeatureArgs);
const loadMdsControlTowerExperienceArgs = {
    actionPrefix: `${reduxActionTypePrefix}/LOAD_MDS_CONTROL_TOWER_EXPERIENCE`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.mds_data,
        inputPayload.managementGroup,
        IReducerKeys.mds_control_tower_experience_async,
    ],
    loadResource: (payload) => getMdsSection(payload, MasterDataSections.ControlTowerExperience),
    onCompleteSuccess: (result) => result,
};
export const loadMdsControlTowerExperienceEpicReducer = loadResourcesUtils(loadMdsControlTowerExperienceArgs);
const loadMdsAnalysisConfigArgs = {
    actionPrefix: `${reduxActionTypePrefix}/LOAD_MDS_ANALYSIS_CONFIG_EXPERIENCE`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.mds_data,
        inputPayload.managementGroup,
        IReducerKeys.mds_analysis_config_async,
    ],
    loadResource: (payload) => getMdsSection(payload, MasterDataSections.AnalysisConfig),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: ({ workspaceId }, AnalysisConfig) => afterLoadAnalysisConfigActions(AnalysisConfig, workspaceId),
};
export const loadMdsAnalysisConfigEpicReducer = loadResourcesUtils(loadMdsAnalysisConfigArgs);
const LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX = 'LOAD_METRICS_ANALYSIS_TEMPLATE';
const loadMetricsAnalysisTemplateArgs = {
    actionPrefix: `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.metrics_analysis_template_data,
        inputPayload.templateName,
        IReducerKeys.analysis_template_async,
    ],
    loadResource: ({ workspaceId, templateName }) => MetricServiceResource.getAnalysisTemplate(workspaceId, templateName),
    onCompleteSuccess: (result) => result,
    dontLoad(inputPayload, state) {
        return state.progressionScorecard.metrics_analysis_template_data[inputPayload.templateName]
            ? [AsyncRequestStatus.Completed, AsyncRequestStatus.Pending, AsyncRequestStatus.Failed].includes(state.progressionScorecard.metrics_analysis_template_data[inputPayload.templateName][IReducerKeys.analysis_template_async].status)
            : false;
    },
};
export const loadMetricsAnalysisTemplateEpicReducer = loadResourcesUtils(loadMetricsAnalysisTemplateArgs);
const loadAnalysisGroupArgs = {
    actionPrefix: `${reduxActionTypePrefix}/LOAD_ANALYSIS_GROUP`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.analysis_data,
        inputPayload.experimentStepId,
        IReducerKeys.analysis_group_async,
    ],
    loadResource: (payload) => AnalysisResource.getAnalysisGroup(payload.workspaceId, payload.experimentStepId),
    onCompleteSuccess: (result) => result,
};
export const loadAnalysisGroupEpicReducer = loadResourcesUtils(loadAnalysisGroupArgs);
const createAnalysisGroupArgs = {
    actionPrefix: `${reduxActionTypePrefix}/CREATE_ANALYSIS_GROUP`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.analysis_data,
        inputPayload.experimentStepId,
        IReducerKeys.create_analysis_group_async,
    ],
    loadResource: (payload) => LegacyAnalysisResource.createNewAnalysisGroupsV2(payload.analysisStudyGroupCreateRequest),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: (inputPayload) => {
        const { workspaceId, experimentStepId } = inputPayload;
        return [loadAnalysisGroupEpicReducer.actionCreators.load({ workspaceId, experimentStepId })];
    },
};
export const createAnalysisGroupEpicReducer = loadResourcesUtils(createAnalysisGroupArgs);
const loadAnalysisRequestFormArgs = {
    actionPrefix: `${reduxActionTypePrefix}/LOAD_ANALYSIS_REQUEST_FORM`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.analysis_data,
        inputPayload.experimentStepId,
        IReducerKeys.analysis_request_form_async,
    ],
    loadResource: (payload) => analysisResourcesInstance.getAnalysisRequestForm(payload.experimentStepId, false),
    onCompleteSuccess: (result) => result,
};
export const loadAnalysisRequestFormEpicReducer = loadResourcesUtils(loadAnalysisRequestFormArgs);
const deleteAnalysisGroupArgs = {
    actionPrefix: `${reduxActionTypePrefix}/DELETE_ANALYSIS_GROUP`,
    reduxKeyNested: ({ analysisGroupId }) => [
        IReducerKeys.analysis_delete_data,
        analysisGroupId,
        IReducerKeys.analysis_group_delete_async,
    ],
    loadResource: ({ workspaceId, analysisGroupId, analysisTemplateNames }) => {
        return AnalysisResource.deleteAnalysisGroup(workspaceId, analysisGroupId, analysisTemplateNames);
    },
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: ({ analysisGroupId, allAnalysisGroupIds, experimentStepId, workspaceId }, outputPayload, state) => {
        // state status for current analysis group id not yet updated at this point, we can check the rest to assume completion
        const _a = getAnalysisGroupDeleteData(state, {
            analysisGroupIds: allAnalysisGroupIds,
        }), _b = analysisGroupId, current = _a[_b], restAnalysisGroupDeleteData = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        const statuses = _.map(restAnalysisGroupDeleteData, (value) => { var _a; return (_a = value === null || value === void 0 ? void 0 : value[IReducerKeys.analysis_group_delete_async]) === null || _a === void 0 ? void 0 : _a.status; });
        const completed = allRequestsHaveCompleted(statuses);
        return completed ? [loadAnalysisGroupEpicReducer.actionCreators.load({ experimentStepId, workspaceId })] : [];
    },
};
export const deleteAnalysisGroupEpicReducer = loadResourcesUtils(deleteAnalysisGroupArgs);
const editAnalysisGroupArgs = {
    actionPrefix: `${reduxActionTypePrefix}/EDIT_ANALYSIS_GROUP`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.analysis_data,
        inputPayload.experimentStepId,
        IReducerKeys.create_analysis_group_async,
    ],
    loadResource: (payload) => LegacyAnalysisResource.createNewAnalysisGroupsV2(payload.analysisStudyGroupCreateRequest),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: (inputPayload) => [
        deleteAnalysisGroupEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { allAnalysisGroupIds: [inputPayload.analysisGroupId] })),
    ],
};
export const editAnalysisGroupEpicReducer = loadResourcesUtils(editAnalysisGroupArgs);
export const LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX = 'LOAD_FEATURE_AUTO_TRIGGER_STATE';
const loadFeatureAutoTriggerStateArg = {
    actionPrefix: `${reduxActionTypePrefix}/${LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX}`,
    reduxKeyNested: (inputPayload) => [
        IReducerKeys.features,
        inputPayload.featureId,
        IReducerKeys.feature_auto_trigger_state_async,
    ],
    loadResource: (payload) => {
        const { workspaceId, featureId } = payload;
        return AnalysisResource.getFeatureAutoTriggeringState(workspaceId, featureId);
    },
    onCompleteSuccess: (result) => {
        return result;
    },
    onLoaded: (response) => {
        if (!!response && response.statusCode == 404) {
            const featureAutoTriggerStateResult = {
                value: false,
                error: {
                    code: '404',
                    message: 'Not Found',
                },
            };
            return {
                isSuccessful: true,
                data: featureAutoTriggerStateResult,
            };
        }
    },
};
export const loadFeatureAutoTriggerStateEpicReducer = loadResourcesUtils(loadFeatureAutoTriggerStateArg);
export const reducer = (state = defaultReducerState(), action) => {
    var _a, _b;
    state = loadRootFeatureEpicReducer.reduxChange(state, action);
    state = loadMdsControlTowerExperienceEpicReducer.reduxChange(state, action);
    state = loadMdsAnalysisConfigEpicReducer.reduxChange(state, action);
    state = loadAnalysisGroupEpicReducer.reduxChange(state, action);
    state = createAnalysisGroupEpicReducer.reduxChange(state, action);
    state = deleteAnalysisGroupEpicReducer.reduxChange(state, action);
    state = editAnalysisGroupEpicReducer.reduxChange(state, action);
    state = loadAnalysisRequestFormEpicReducer.reduxChange(state, action);
    state = loadFeatureAutoTriggerStateEpicReducer.reduxChange(state, action);
    if (action.type === `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}/LOADING`) {
        state = Object.assign(Object.assign({}, state), { [IReducerKeys.metrics_analysis_template_data]: Object.assign({}, setMetricsAnalysisTemplatesInReduxWhenLoading(state, action.payload)) });
    }
    if (action.type === `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}/LOADED`) {
        state = Object.assign(Object.assign({}, state), { [IReducerKeys.metrics_analysis_template_data]: Object.assign({}, setMetricsAnalysisTemplatesInReduxWhenLoaded(state, (_b = (_a = action.outputPayloadAsync) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [], action.outputPayloadAsync)) });
    }
    return state;
};
export const epics = combineEpics(loadRootFeatureEpicReducer.epic, loadMdsControlTowerExperienceEpicReducer.epic, loadMdsAnalysisConfigEpicReducer.epic, loadAnalysisGroupEpicReducer.epic, createAnalysisGroupEpicReducer.epic, deleteAnalysisGroupEpicReducer.epic, editAnalysisGroupEpicReducer.epic, loadMetricsAnalysisTemplateEpicReducer.epic, loadAnalysisRequestFormEpicReducer.epic, loadFeatureAutoTriggerStateEpicReducer.epic);

//# sourceMappingURL=ProgressionScorecard.ducks.js.map
